import { ButtonERP } from "@finanedi.es/storybook"
import {
  useCuentaContableEmpresaComisionAperturaPrestamoConcedido,
  useCuentaContableEmpresaComisionAperturaPrestamoRecibido,
  useCuentaContableEmpresaComisionCorretajePrestamoConcedido,
  useCuentaContableEmpresaComisionCorretajePrestamoRecibido,
  useCuentaContableEmpresaComisionDisposicionPrestamoConcedido,
  useCuentaContableEmpresaComisionDisposicionPrestamoRecibido,
  useCuentaContableEmpresaComisionEstudioPrestamoConcedido,
  useCuentaContableEmpresaComisionEstudioPrestamoRecibido,
  useCuentaContableEmpresaComisionOtraPrestamoConcedido,
  useCuentaContableEmpresaComisionOtraPrestamoRecibido,
} from "api/CuentaContableEmpresa.hook"
import {
  useCuentaContableCuentaComisionAperturaPrestamoConcedido,
  useCuentaContableCuentaComisionAperturaPrestamoRecibido,
  useCuentaContableCuentaComisionCorretajePrestamoConcedido,
  useCuentaContableCuentaComisionCorretajePrestamoRecibido,
  useCuentaContableCuentaComisionDisposicionPrestamoConcedido,
  useCuentaContableCuentaComisionDisposicionPrestamoRecibido,
  useCuentaContableCuentaComisionEstudioPrestamoConcedido,
  useCuentaContableCuentaComisionEstudioPrestamoRecibido,
  useCuentaContableCuentaComisionOtraPrestamoConcedido,
  useCuentaContableCuentaComisionOtraPrestamoRecibido,
} from "api/CuentaContable_Cuenta.hook"
import { CATEGORIA_CUENTA_CONTABLE_ENUM } from "api/Types/CategoriaCuentaContableEnum"
import { DropdownCuentasContablesConModal } from "common/components/DropdownsCuentasContables/DropdownCuentasContablesConModal/DropdownCuentasContablesConModal"
import { ESTADO_TIPO_COMISION } from "common/utils/constants"
import { getTypeValueComision } from "features/Contabilidad/pages/Prestamos/pages/PrestamoDetail/constants"
import useCuentasContables from "features/Tesoreria/hooks/useCuentasContables"
import { nanoid } from "nanoid"
import { Dropdown, DropdownChangeParams } from "primereact/dropdown"
import { InputNumber } from "primereact/inputnumber"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import {
  IMPORTE_TIPO_SELECT_OPTIONS,
  SELECTOR_TIPO,
  TIPO_COMISION_SELECT_OPTIONS,
} from "../../constants"
import "./styles.scss"

const ComisionesForm = ({
  handleBlur,
  values,
  handleElement,
  handleOpenModal,
  tabSelected,
}: $TSMigrationFixMe) => {
  const { getCuentaContablePorDefecto } = useCuentasContables()
  const [contablesComisiones, setContablesComisiones] = useState()
  const [contablesComisionesBase, setContablesComisionesBase] = useState()

  const { t } = useTranslation()
  const [comision, setComision] = useState({
    cuentaContableEmpresaId: values?.originalObject?.cuentaContableEmpresaId,
    tipoImporte: values?.originalObject?.importe.tipoImporte || 1,
    valor: values?.originalObject?.importe.valor,
    tipoComision: values?.originalObject?.tipoComision,
  })

  const {
    cuentasContablesEmpresas:
      cuentasContablesComisionOtrasPrestamoConcedidoBase,
  } = useCuentaContableCuentaComisionOtraPrestamoConcedido()
  const {
    cuentasContablesEmpresas: cuentasContablesComisionOtrasPrestamoConcedido,
    cuentasContablesEmpresasRefetch:
      refresListaDeCuentasComisionOtrasPrestamoConcedido,
  } = useCuentaContableEmpresaComisionOtraPrestamoConcedido()
  const initialPorDefectoPrestamoComisionOtrasConcedido =
    getCuentaContablePorDefecto(
      CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_OTRA_PRESTAMO_CONCEDIDO
    )

  const {
    cuentasContablesEmpresas:
      cuentasContablesComisionCorretajePrestamoConcedidoBase,
  } = useCuentaContableCuentaComisionCorretajePrestamoConcedido()
  const {
    cuentasContablesEmpresas:
      cuentasContablesComisionCorretajePrestamoConcedido,
    cuentasContablesEmpresasRefetch:
      refresListaDeCuentasComisionCorretajePrestamoConcedido,
  } = useCuentaContableEmpresaComisionCorretajePrestamoConcedido()
  const initialPorDefectoPrestamoComisionCorretajeConcedido =
    getCuentaContablePorDefecto(
      CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_CORRETAJE_PRESTAMO_CONCEDIDO
    )

  const {
    cuentasContablesEmpresas:
      cuentasContablesComisionDisposicionPrestamoConcedidoBase,
  } = useCuentaContableCuentaComisionDisposicionPrestamoConcedido()
  const {
    cuentasContablesEmpresas:
      cuentasContablesComisionDisposicionPrestamoConcedido,
    cuentasContablesEmpresasRefetch:
      refresListaDeCuentasComisionDisposicionPrestamoConcedido,
  } = useCuentaContableEmpresaComisionDisposicionPrestamoConcedido()
  const initialPorDefectoPrestamoComisionDisposicionConcedido =
    getCuentaContablePorDefecto(
      CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_DISPOSICION_PRESTAMO_CONCEDIDO
    )

  const {
    cuentasContablesEmpresas:
      cuentasContablesComisionEstudioPrestamoConcedidoBase,
  } = useCuentaContableCuentaComisionEstudioPrestamoConcedido()
  const {
    cuentasContablesEmpresas: cuentasContablesComisionEstudioPrestamoConcedido,
    cuentasContablesEmpresasRefetch:
      refresListaDeCuentasComisionEstudioPrestamoConcedido,
  } = useCuentaContableEmpresaComisionEstudioPrestamoConcedido()
  const initialPorDefectoPrestamoComisionEstudioConcedido =
    getCuentaContablePorDefecto(
      CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_ESTUDIO_PRESTAMO_CONCEDIDO
    )

  const {
    cuentasContablesEmpresas:
      cuentasContablesComisionAperturaPrestamoConcedidoBase,
  } = useCuentaContableCuentaComisionAperturaPrestamoConcedido()
  const {
    cuentasContablesEmpresas: cuentasContablesComisionAperturaPrestamoConcedido,
    cuentasContablesEmpresasRefetch:
      refresListaDeCuentasComisionAperturaPrestamoConcedido,
  } = useCuentaContableEmpresaComisionAperturaPrestamoConcedido()
  const initialPorDefectoPrestamoComisionAperturaConcedido =
    getCuentaContablePorDefecto(
      CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_APERTURA_PRESTAMO_CONCEDIDO
    )

  const {
    cuentasContablesEmpresas:
      cuentasContablesComisionAperturaPrestamoRecibidoBase,
  } = useCuentaContableCuentaComisionAperturaPrestamoRecibido()
  const {
    cuentasContablesEmpresas: cuentasContablesComisionAperturaPrestamoRecibido,
    cuentasContablesEmpresasRefetch:
      refresListaDeCuentasComisionAperturaPrestamoRecibido,
  } = useCuentaContableEmpresaComisionAperturaPrestamoRecibido()
  const initialPorDefectoPrestamoComisionAperturaRecibido =
    getCuentaContablePorDefecto(
      CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_APERTURA_PRESTAMO_RECIBIDO
    )

  const {
    cuentasContablesEmpresas:
      cuentasContablesComisionEstudioPrestamoRecibidoBase,
  } = useCuentaContableCuentaComisionEstudioPrestamoRecibido()
  const {
    cuentasContablesEmpresas: cuentasContablesComisionEstudioPrestamoRecibido,
    cuentasContablesEmpresasRefetch:
      refresListaDeCuentasComisionEstudioPrestamoRecibido,
  } = useCuentaContableEmpresaComisionEstudioPrestamoRecibido()
  const initialPorDefectoPrestamoComisionEstudioRecibido =
    getCuentaContablePorDefecto(
      CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_ESTUDIO_PRESTAMO_RECIBIDO
    )

  const {
    cuentasContablesEmpresas:
      cuentasContablesComisionDisposicionPrestamoRecibidoBase,
  } = useCuentaContableCuentaComisionDisposicionPrestamoRecibido()
  const {
    cuentasContablesEmpresas:
      cuentasContablesComisionDisposicionPrestamoRecibido,
    cuentasContablesEmpresasRefetch:
      refresListaDeCuentasComisionDisposicionPrestamoRecibido,
  } = useCuentaContableEmpresaComisionDisposicionPrestamoRecibido()
  const initialPorDefectoPrestamoComisionDisposicionRecibido =
    getCuentaContablePorDefecto(
      CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_DISPOSICION_PRESTAMO_RECIBIDO
    )

  const {
    cuentasContablesEmpresas:
      cuentasContablesComisionCorretajePrestamoRecibidoBase,
  } = useCuentaContableCuentaComisionCorretajePrestamoRecibido()
  const {
    cuentasContablesEmpresas: cuentasContablesComisionCorretajePrestamoRecibido,
    cuentasContablesEmpresasRefetch:
      refresListaDeCuentasComisionCorretajePrestamoRecibido,
  } = useCuentaContableEmpresaComisionCorretajePrestamoRecibido()
  const initialPorDefectoPrestamoComisionCorretajeRecibido =
    getCuentaContablePorDefecto(
      CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_CORRETAJE_PRESTAMO_RECIBIDO
    )

  const {
    cuentasContablesEmpresas: cuentasContablesComisionOtrasPrestamoRecibidoBase,
  } = useCuentaContableCuentaComisionOtraPrestamoRecibido()
  const {
    cuentasContablesEmpresas: cuentasContablesComisionOtrasPrestamoRecibido,
    cuentasContablesEmpresasRefetch:
      refresListaDeCuentasComisionOtrasPrestamoRecibido,
  } = useCuentaContableEmpresaComisionOtraPrestamoRecibido()
  const initialPorDefectoPrestamoComisionOtrasRecibido =
    getCuentaContablePorDefecto(
      CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_OTRA_PRESTAMO_RECIBIDO
    )

  const updateInitialValue = (comisionType: $TSMigrationFixMe) => {
    switch (comisionType) {
      case 1:
        return tabSelected === 1
          ? initialPorDefectoPrestamoComisionAperturaConcedido
          : initialPorDefectoPrestamoComisionAperturaRecibido
      case 2:
        return tabSelected === 1
          ? initialPorDefectoPrestamoComisionEstudioConcedido
          : initialPorDefectoPrestamoComisionEstudioRecibido

      case 3:
        return tabSelected === 1
          ? initialPorDefectoPrestamoComisionDisposicionConcedido
          : initialPorDefectoPrestamoComisionDisposicionRecibido

      case 4:
        return tabSelected === 1
          ? initialPorDefectoPrestamoComisionCorretajeConcedido
          : initialPorDefectoPrestamoComisionCorretajeRecibido

      case 5:
        return tabSelected === 1
          ? initialPorDefectoPrestamoComisionOtrasConcedido
          : initialPorDefectoPrestamoComisionOtrasRecibido

      default:
        return ""
    }
  }
  // @ts-expect-error TS(7030): Not all code paths return a value.
  const updateListasComisiones = (comisionType: $TSMigrationFixMe) => {
    switch (comisionType) {
      // TODO: Magic numbers
      case 1:
        if (tabSelected === 1) {
          setContablesComisiones(
            // @ts-expect-error TS(2345): Argument of type 'CuentaContableEmpresaReadingDtoP...
            cuentasContablesComisionAperturaPrestamoConcedido
          )
          setContablesComisionesBase(
            // @ts-expect-error TS(2345): Argument of type 'CuentaContableCuentaReadingDtoPr...
            cuentasContablesComisionAperturaPrestamoConcedidoBase
          )
        } else {
          setContablesComisiones(
            // @ts-expect-error TS(2345): Argument of type 'CuentaContableEmpresaReadingDtoP...
            cuentasContablesComisionAperturaPrestamoRecibido
          )
          setContablesComisionesBase(
            // @ts-expect-error TS(2345): Argument of type 'CuentaContableCuentaReadingDtoPr...
            cuentasContablesComisionAperturaPrestamoRecibidoBase
          )
        }
        break
      case 2:
        if (tabSelected === 1) {
          setContablesComisiones(
            // @ts-expect-error TS(2345): Argument of type 'CuentaContableEmpresaReadingDtoP...
            cuentasContablesComisionEstudioPrestamoConcedido
          )
          setContablesComisionesBase(
            // @ts-expect-error TS(2345): Argument of type 'CuentaContableCuentaReadingDtoPr...
            cuentasContablesComisionEstudioPrestamoConcedidoBase
          )
        } else {
          setContablesComisiones(
            // @ts-expect-error TS(2345): Argument of type 'CuentaContableEmpresaReadingDtoP...
            cuentasContablesComisionEstudioPrestamoRecibido
          )
          setContablesComisionesBase(
            // @ts-expect-error TS(2345): Argument of type 'CuentaContableCuentaReadingDtoPr...
            cuentasContablesComisionEstudioPrestamoRecibidoBase
          )
        }
        break
      case 3:
        if (tabSelected === 1) {
          setContablesComisiones(
            // @ts-expect-error TS(2345): Argument of type 'CuentaContableEmpresaReadingDtoP...
            cuentasContablesComisionDisposicionPrestamoConcedido
          )
          setContablesComisionesBase(
            // @ts-expect-error TS(2345): Argument of type 'CuentaContableCuentaReadingDtoPr...
            cuentasContablesComisionDisposicionPrestamoConcedidoBase
          )
        } else {
          setContablesComisiones(
            // @ts-expect-error TS(2345): Argument of type 'CuentaContableEmpresaReadingDtoP...
            cuentasContablesComisionDisposicionPrestamoRecibido
          )
          setContablesComisionesBase(
            // @ts-expect-error TS(2345): Argument of type 'CuentaContableCuentaReadingDtoPr...
            cuentasContablesComisionDisposicionPrestamoRecibidoBase
          )
        }
        break
      case 4:
        if (tabSelected === 1) {
          setContablesComisiones(
            // @ts-expect-error TS(2345): Argument of type 'CuentaContableEmpresaReadingDtoP...
            cuentasContablesComisionCorretajePrestamoConcedido
          )
          setContablesComisionesBase(
            // @ts-expect-error TS(2345): Argument of type 'CuentaContableCuentaReadingDtoPr...
            cuentasContablesComisionCorretajePrestamoConcedidoBase
          )
        } else {
          setContablesComisiones(
            // @ts-expect-error TS(2345): Argument of type 'CuentaContableEmpresaReadingDtoP...
            cuentasContablesComisionCorretajePrestamoRecibido
          )
          setContablesComisionesBase(
            // @ts-expect-error TS(2345): Argument of type 'CuentaContableCuentaReadingDtoPr...
            cuentasContablesComisionCorretajePrestamoRecibidoBase
          )
        }
        break
      case 5:
        if (tabSelected === 1) {
          // @ts-expect-error TS(2345): Argument of type 'CuentaContableEmpresaReadingDtoP...
          setContablesComisiones(cuentasContablesComisionOtrasPrestamoConcedido)
          setContablesComisionesBase(
            // @ts-expect-error TS(2345): Argument of type 'CuentaContableCuentaReadingDtoPr...
            cuentasContablesComisionOtrasPrestamoConcedidoBase
          )
        } else {
          // @ts-expect-error TS(2345): Argument of type 'CuentaContableEmpresaReadingDtoP...
          setContablesComisiones(cuentasContablesComisionOtrasPrestamoRecibido)
          setContablesComisionesBase(
            // @ts-expect-error TS(2345): Argument of type 'CuentaContableCuentaReadingDtoPr...
            cuentasContablesComisionOtrasPrestamoRecibidoBase
          )
        }
        break
      default:
        return ""
    }
  }

  const getListasComisiones = (comisionType: $TSMigrationFixMe) => {
    switch (comisionType) {
      case 1:
        return tabSelected === 1
          ? cuentasContablesComisionAperturaPrestamoConcedido
          : cuentasContablesComisionAperturaPrestamoRecibido
      case 2:
        return tabSelected === 1
          ? cuentasContablesComisionEstudioPrestamoConcedido
          : cuentasContablesComisionEstudioPrestamoRecibido
      case 3:
        return tabSelected === 1
          ? cuentasContablesComisionDisposicionPrestamoConcedido
          : cuentasContablesComisionDisposicionPrestamoRecibido
      case 4:
        return tabSelected === 1
          ? cuentasContablesComisionCorretajePrestamoConcedido
          : cuentasContablesComisionCorretajePrestamoRecibido
      case 5:
        return tabSelected === 1
          ? cuentasContablesComisionOtrasPrestamoConcedido
          : cuentasContablesComisionOtrasPrestamoRecibido
      default:
        return []
    }
  }

  const refreshFetchDataTest = (comisionType: $TSMigrationFixMe) => {
    switch (comisionType) {
      // TODO: Magic numbers
      case 1:
        return tabSelected === 1
          ? refresListaDeCuentasComisionAperturaPrestamoConcedido
          : refresListaDeCuentasComisionAperturaPrestamoRecibido

      case 2:
        return tabSelected === 1
          ? refresListaDeCuentasComisionEstudioPrestamoConcedido
          : refresListaDeCuentasComisionEstudioPrestamoRecibido

      case 3:
        return tabSelected === 1
          ? refresListaDeCuentasComisionDisposicionPrestamoConcedido
          : refresListaDeCuentasComisionDisposicionPrestamoRecibido

      case 4:
        return tabSelected === 1
          ? refresListaDeCuentasComisionCorretajePrestamoConcedido
          : refresListaDeCuentasComisionCorretajePrestamoRecibido

      case 5:
        return tabSelected === 1
          ? refresListaDeCuentasComisionOtrasPrestamoConcedido
          : refresListaDeCuentasComisionOtrasPrestamoRecibido

      default:
        return null
    }
  }

  const handleChangeTipoComision = (value: $TSMigrationFixMe) => {
    setComision({
      ...comision,
      tipoComision: value,
      cuentaContableEmpresaId: updateInitialValue(value),
    })
    updateListasComisiones(value)
  }

  const handleChange = (value: $TSMigrationFixMe, key: $TSMigrationFixMe) => {
    setComision({ ...comision, [key]: value })
  }

  const handleSelectCtaContableInteres = (
    newCuentaContable: DropdownChangeParams
  ) => {
    handleChange(newCuentaContable.value, SELECTOR_TIPO[1])
  }

  const handleAddComision = () => {
    // @ts-expect-error TS(2339): Property 'filter' does not exist on type 'never'.
    const cuentaContable = contablesComisiones?.filter(
      (cuenta: $TSMigrationFixMe) => {
        return cuenta.id === comision?.cuentaContableEmpresaId
      }
    )[0]
    if (
      comision.cuentaContableEmpresaId &&
      comision.valor >= 0 &&
      comision.tipoComision
    ) {
      handleElement({
        label: ESTADO_TIPO_COMISION(t)[comision.tipoComision].fullText,
        value: getTypeValueComision(comision?.tipoImporte, comision?.valor),
        extraValue: cuentaContable?.nombre,
        key: values?.key || nanoid(),
        elementId: values?.elementId || nanoid(),
        originalObject: {
          cuentaContableEmpresaId: comision?.cuentaContableEmpresaId,
          importe: {
            tipoImporte: comision?.tipoImporte,
            valor: comision?.valor,
          },
          tipoComision: comision?.tipoComision,
        },
      })
    }
  }

  useEffect(() => {
    if (values) {
      getListasComisiones(comision.tipoComision)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values])

  useEffect(() => {
    updateListasComisiones(comision.tipoComision)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    cuentasContablesComisionAperturaPrestamoConcedido,
    cuentasContablesComisionAperturaPrestamoRecibido,
    cuentasContablesComisionEstudioPrestamoConcedido,
    cuentasContablesComisionEstudioPrestamoRecibido,
    cuentasContablesComisionDisposicionPrestamoConcedido,
    cuentasContablesComisionDisposicionPrestamoRecibido,
    cuentasContablesComisionCorretajePrestamoConcedido,
    cuentasContablesComisionCorretajePrestamoRecibido,
    cuentasContablesComisionOtrasPrestamoConcedido,
    cuentasContablesComisionOtrasPrestamoRecibido,
  ])

  return (
    <>
      <div className='mb-3 p-fluid'>
        <div className='p-field'>
          <div className='mb-3 select-main_content'>
            <div className='input_box'>
              <label>{t("impuestos.modalNew.typeLabel")}</label>
              <Dropdown
                options={TIPO_COMISION_SELECT_OPTIONS(t)}
                value={comision.tipoComision}
                // @ts-expect-error TS(2769): No overload matches this call.
                placeholder={t("others.placeholderSelectType")}
                fluid
                id='tipoComision'
                name='tipoComision'
                onBlur={handleBlur}
                disabled={values?.remesaId}
                onChange={(e) => handleChangeTipoComision(e.target.value)}
              />
            </div>
            <div className='text-left col-md-12 col-lg-5 select_container'>
              <label>{t("impuestos.modalNew.taxLabel")}</label>
              <div className='p-inputgroup'>
                <Dropdown
                  value={comision.tipoImporte}
                  options={IMPORTE_TIPO_SELECT_OPTIONS}
                  onChange={(e) => handleChange(e.value, "tipoImporte")}
                />
                <InputNumber
                  id='valor'
                  name='valor'
                  value={comision?.valor}
                  onBlur={handleBlur}
                  disabled={values?.remesaId}
                  onChange={(e) => handleChange(e.value, "valor")}
                  className='comisiones-input'
                  maxFractionDigits={2}
                />
              </div>
            </div>
          </div>
          <div className='tw-w-full'>
            <DropdownCuentasContablesConModal
              cuentasContablesOptions={getListasComisiones(
                comision?.tipoComision
              )}
              disabled={!comision.tipoComision}
              dropdownValue={comision?.cuentaContableEmpresaId ?? ""}
              onChange={handleSelectCtaContableInteres}
              listaDeCuentasBase={contablesComisionesBase}
              refreshFetchData={refreshFetchDataTest(comision?.tipoComision)}
              withCreateCuenta
            />
          </div>
        </div>
      </div>
      <div>
        <div className='tw-flex tw-justify-end tw-gap-3 tw-mt-8'>
          <ButtonERP
            onClick={() => handleOpenModal(null, false)}
            customize={{
              type: "white",
              size: "md",
            }}
            label={`${t("impuestos.modalNew.cancelButton")}`}
          />
          <ButtonERP
            onClick={handleAddComision}
            customize={{
              type: "secondary",
              size: "md",
            }}
            className='tw-w-25'
            label={
              values?.elementId
                ? `${t("impuestos.modalNew.editButton")}`
                : `${t("impuestos.modalNew.createButton")}`
            }
          />
        </div>
      </div>
    </>
  )
}

export default ComisionesForm
